import {AdjustCol, AdjustCol2, StringCol, ViewOnly} from "../../../../misc/scroller/Table";
import {comparePhase, isValidPhase} from "../../../../misc/Phase";

export function PhaseCol<T extends {id: number; phase: string}>() {
    return AdjustCol2<T>(StringCol<T>("Phase", "phase" as any, 60), old => ({
        editable: Object.assign({}, old.editable, {
            validate: (str: string) => {
                if(!isValidPhase(str)) throw new Error("Phase must be numbers like 1, 1.1, 1-1 or 1.1.1");
            },
        }),
        sort: (a: T, b: T) => comparePhase(a.phase, b.phase),
    }));
}

export function PhaseViewCol<T extends {id: number}>(key: keyof T & string, width = 70) {
    return AdjustCol<T>(ViewOnly<T>(StringCol<T>("Phase", key as any, width)), {
        sort: (a: T, b: T) => comparePhase(a[key] as any, b[key] as any),
    });
}
